import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	pollSubmissionFailure: {
		id: 'poll.submission.failure',
		defaultMessage: 'An error occurred when submitting the poll. Please try again.',
		description: 'The error message shown when an error occurs during poll submission',
	},
});
